import util from '../../assets/js/util';
import $ajax from '../../assets/js/interceptor';
import LocalStorage from 'localStorage';
export default {
  state: {
    access: ''
  },
  mutations: {
    setAccess (state, permissionList) {
      state.access = permissionList;
    }
  },
  actions: {
    getUserPermissions ({ dispatch, commit }) { // 获取当前登录用的权限
      // $ajax.get('/permissions/fetch_user_permissions').then(function (res) {
      //   const permissionList = util.parseUserPermissions(res.data);
      //   if (permissionList.length == 0) {
      //     alert('您没有该系统的操作权限，请确认用户信息后，重新登录');
      //     dispatch('logout');
      //   } else {
      //     Cookies.set('userPermissions', permissionList.join(','));
      //     commit('setAccess', permissionList);
      //   }
      // });
      LocalStorage.setItem('userPermissions', 'test');
      commit('setAccess', 'test');
    },
    logout () { // 退出登录
      // $ajax.get('/wallstreet/user/exit_logout').then(function (res) {
      //   if (res.data.retCode == 200) {
      //     LocalStorage.removeItem('userPermissions');
      //     window.location.href = res.data.body;
      //   } else alert(res.data.message);
      // });
    }
  },
  getters: {
    //
  }
};
